export default {
  女装: "Әйелдер киімі",
  男装: "Ерлердікі",
  手机和小工具: "Ұялы телефон және шағын құралдар",
  居家生活: "Үй өмірі",
  电脑及周边设备: "Компьютерлік және перифериялық жабдықтар",
  美容及个人护理: "Сұлулық және жеке күтім",
  家用电器: "Аспап",
  健康与保健: "Денсаулық және денсаулық сақтау",
  食品和饮料: "Тамақ және сусын",
  玩具_儿童和婴儿: "Ойыншықтар, балалар мен сәбилер",
  童装时尚: "Балалардың киімдері сәні",
  视频游戏: "видео ойындары",
  运动与户外: "Жаттығу және ашық",
  爱好与书籍: "Хобби және кітаптар",
  相机和无人机: "Камера және дрондар",
  宠物食品及用品: "Үй жануарларының тамағы және жабдықтары",
  女士包袋: "Ханымдар сөмкесі",
  男士包袋: "Ерлер пакеті",
  珠宝及配饰: "Зергерлік бұйымдар мен керек-жарақтар",
  手表: "қарау",
  女鞋: "Әйелдер аяқ киімі",
  男装鞋: "Ерлер аяқ киімі",
  汽车: "машина",
  我附近的ShopeePay: "Жақын жерде дүкенші",
  餐饮_旅行和服务: "Тамақтану, саяхат және қызмет көрсету",
  旅行及行李: "Саяхат және жүк",
  各种各样的: "Түрлі",
  我是来买什么的: "Мен сатып алу үшін келдім",
  对不起_找不到_相关的商品:
    "Кешіріңіз, сіз [{0}] байланысты өнімдерді таба алмайсыз",
  类别: "санат",
  产品: "өнім",
  店铺: "Дүкен",
  首页: "Алдыңғы бет",
  限时秒杀: "Шектеулі уақыт шегі",
  博客: "қожалдыру",
  所有品牌: "Барлық брендтер",
  所有类别: "Барлық санаттар",
  我的购物车: "Менің себетім",
  发货信息: "Жеткізу туралы ақпарат",
  交货信息: "Жеткізу туралы ақпарат",
  付款: "Төлем",
  确认: "растау",
  您的购物车是空的: "Сіздің себетіңіз бос",
  价格: "баға",
  税: "Салық",
  数量: "сан",
  总计: "жалпы",
  移除: "Кетіру",
  返回商店: "Дүкенге оралу",
  继续发货: "Жеткізуді жалғастырыңыз",
  筛选: "сүзу",
  价格范围: "Баға",
  排序方式: "бойынша сұрыптау",
  最新: "жаңарған",
  最旧: "Ескі",
  价格从低到高: "Төменнен жоғарыдан жоғары баға",
  价格从高到低: "Жоғарыдан төмен",
  选择交货类型: "Жеткізу түрін таңдаңыз",
  送货上门: "Жеткізілім",
  继续付款: "Төлеуді жалғастырыңыз",
  任何其他信息: "Кез келген басқа ақпарат",
  或者: "немесе",
  您的钱包余额: "Әмиян балансы",
  余额不足: "Балансты жеткіліксіз",
  支付: "Төлеу",
  我同意: "Мен келісемін",
  条款和条件: "Шарттар",
  退货政策: "ТАУАРДЫ ҚАЙТАРУ ШАРТТАРЫ",
  隐私政策: "Жалғыздық",
  概括: "Қорытындылау",
  项目: "жоба",
  全部的: "Барлығы жасақтау",
  小计: "Салу",
  总运费: "Жалпы жүк",
  有优惠码吗_在这里输入: "Жеңілдік коды бар ма? Мұнда енгізіңіз",
  申请: "Өтініш беру",
  编辑: "редакциялау",
  删除: "жою",
  添加新地址: "Жаңа мекен-жай қосу",
  继续交货信息: "Жеткізу туралы ақпаратты жалғастырыңыз",
  选择一个地址: "Мекенжайды таңдаңыз",
  购买历史: "Тарих сатып алыңыз",
  下载: "сайлау",
  已发送退款请求: "Қайтару сұранысы қайтару туралы өтініш жібереді",
  对比: "қарама-қарсылық",
  对话: "диалог",
  我的钱包: "Менің әмияным",
  工单: "Жұмыс тәртібі",
  管理个人资料: "Жеке ақпаратты басқару",
  登出: "Шығу",
  重置对比列表: "Салыстыру тізімін қалпына келтіру",
  您的对比列表为空: "Салыстыру тізіміңіз бос",
  在您的购物车中: "Себетіңізде",
  在您的愿望清单中: "Сіздің тілектеріңізде",
  在您的预定列表中: "Сіздің жоспарланған тізіміңізде",
  下载您的产品: "Өнімді жүктеңіз",
  选项: "Талғау",
  什么都没找到: "Мен ештеңе таппадым",
  特色产品: "Арнайы өнім",
  最畅销: "Ең жақсы -",
  前_名: "Алдыңғы {0} аты",
  查看更多: "Көбірек қарау",
  查看所有类别: "Барлық санаттарды қарау",
  十大品牌: "Топ-он брендтер",
  查看所有品牌: "Барлық брендтерді қарау",
  登录: "Кіру",
  手机号码: "телефон нөмірі",
  密码: "пароль",
  密码长度为6到16个字符: "Құпия сөздің ұзындығы 6-дан 16 таңбаға дейін",
  验证码: "Тексеру коды",
  登录中: "Кіру",
  游客登录: "Туристік кіру",
  注册您的商店: "Дүкенді тіркеңіз",
  现在申请: "Қазір өтініш беріңіз",
  成为商家: "Саудагерге айналады",
  现在注册: "Қазір тіркеліңіз",
  登录成功: "Сәтті кіру",
  通知: "хабарлау",
  未找到通知: "Хабарлама жоқ",
  评论: "Ескерту",
  估计运输时间: "Бағаланған тасымалдау уақыты",
  天: "аспан",
  所售: "Сату",
  给商家留言: "Сатушыға хабарлама қалдырыңыз",
  规格: "Техникалық шарғы",
  库存: "Қоймада",
  总价: "Жалпы баға",
  添加到购物车: "Себетке қосу",
  立即购买: "Қазір сатып алыңыз",
  缺货: "Қоймадан тыс",
  添加到愿望清单: "Тілектер тізіміне қосыңыз",
  加入对比列表: "Салыстыру тізімін қосыңыз",
  退款: "Төлеу",
  查看条款: "Сөйлемді қарау",
  分享: "бөлу",
  描述: "сипаттау",
  相关产品: "Байланысты өнімдер",
  没有人问过商家: "Ешкім саудагерден сұрамады",
  该产品暂无评论: "Бұл өнім туралы түсінік жоқ",
  客户评论: "Тұтынушыға түсініктеме",
  访问商店: "Дүкенге бару",
  畅销产品: "Ең жақсы -",
  日期: "дата",
  订单编号: "Тапсырыс нөмірі",
  总额: "паушалдық сома",
  状态: "штат",
  愿望清单: "Тілектер тізімі",
  还没有添加任何东西: "Әлі ештеңе қосқан жоқпын",
  注册: "тіркеу",
  邀请码: "Шақыру коды",
  请输入邀请码: "Шақыру кодын енгізіңіз",
  用户名: "пайдаланушы аты",
  请输入用户名: "Пайдаланушы атын енгізіңіз",
  用户名长度为6_14个字符: "Пайдаланушының аты - 6-14 таңба",
  昵称: "Ник атауы",
  请输入手机号码: "Ұялы телефон нөмірін енгізіңіз",
  手机号码格式错误: "Ұялы телефон нөмірінің форматтау қатесі",
  密码长度为6_16个字符: "Құпия сөздің ұзындығы - 6-16 таңба",
  确认密码: "Құпия сөзді Растау",
  请输入确认密码: "Растау паролін енгізіңіз",
  提款密码: "Құпия сөзді алу",
  请输入提款密码: "Құпия сөзді енгізіңіз",
  提款密码长度为4_16个字符: "Шығару паролінің ұзындығы - 4-16 таңба",
  请输入验证码: "Тексеру кодын енгізіңіз",
  在_s后发送: "{0} s-ден кейін жіберіңіз",
  发送验证码: "Растау кодын жіберіңіз",
  注册即表示您同意我们的条款和条件:
    "Тіркелу дегеніміз - сіз біздің шарттармен келісесіз.",
  创建账号: "Аккаунты құру",
  验证码发送成功: "Тексеру коды сәтті жібереді",
  确认密码不一致: "Парольдің сәйкес келмейтінін растаңыз",
  提款密码必须为数字: "Шығару паролі нөмірленуі керек",
  注册成功: "Тіркеуге дейін",
  购物车: "Кәрзеңке",
  账户: "Шот",
  我的账户: "Менің аккаунтым",
  已经有一个账户: "Қазірдің өзінде тіркелгі бар",
  新地址: "Жаңа мекен-жай",
  编辑地址: "Редактордың мекен-жайы",
  保存: "жинау",
  是否默认: "Әдепкі болсын",
  具体地址: "Нақты мекен-жайы",
  请输入具体地址: "Нақты мекенжайды енгізіңіз",
  地区: "облыс",
  请输入地区: "Өтінемін, аймаққа кіріңіз",
  城市: "Қала",
  请输入城市: "ҚАЛАДЫ",
  省份: "провинция",
  请输入省份: "Провинцияға кіріңіз",
  邮政编码: "Пошта Индексі",
  请输入邮政编码: "Пошта кодын енгізіңіз",
  电话号码: "Телефон нөмірі",
  请输入电话号码: "Телефон нөмірін енгізіңіз",
  收货人: "жүк алушы",
  请输入收货人: "Жүк алушыны енгізіңіз",
  保存成功: "Сәтті болыңыз",
  最畅销的商家: "Ең жақсы саудагер",
  查看所有的商家: "Барлық саудагерлерді тексеріңіз",
  支持政策: "Қолдау саясаты",
  您的电子邮件地址: "Сіздің электронды пошта адресіңіз",
  订阅: "жазылу",
  联系方式: "Байланыс ақпараты",
  地址: "айналу",
  美国伊利诺伊州霍夫曼庄园: "Холфман Манор, Иллинойс, АҚШ",
  快速链接: "Жылдам сілтеме",
  商家政策: "Сату саясаты",
  submit: "бағыну",
  提款银行卡: "ADBB картасы",
  我的面板: "Менің панелім",
  提示: "тұспал",
  确定登出吗: "Сіз кіргеніңізге сенімдісіз бе?",
  确定: "Сенімді",
  取消: "Күшін жою",
  项目添加到您的购物车: "Жоба сіздің себетіңізге қосылды",
  经常一起购买: "Жиі сатып алыңыз",
  返回购物: "Қайтару",
  进行结算: "Тексеруді жалғастырыңыз",
  帮助热线: "Жедел желіге көмектесіңіз",
  查看所有通知: "Барлық хабарландыруларды тексеріңіз",
  请输入密码: "Парольді енгізіңіз",
  前往充值: "Қайта зарядтауға барыңыз",
  购物车物品: "Кәрзеңке",
  查看购物车: "Себетті тексеріңіз",
  钱包余额: "Әмиян балансы",
  充值钱包: "Қайта зарядтау дорбасы",
  钱包充值_线下_: "Әмиян қайта зарядтау (офлайн)",
  申请提款: "Шығаруға өтініш беру",
  钱包收支明细: "Әмиян кірістері және шығыстар туралы мәліметтер",
  批准: "мақұлдау",
  提现历史记录: "Қаржылық тарихи рекорд",
  类型: "басу",
  信息: "ақпарат",
  付款方式: "Төлем әдісі",
  请选择付款方式: "Төлем әдісін таңдаңыз",
  Bill_Type_RECHARGE_BACK: "Фондық қайта зарядтау",
  Bill_Type_RECHARGE_ONLINE: "Интернетте қайта зарядтау",
  Bill_Type_RECHARGE_REGISTER: "Тіркеу",
  Bill_Type_RECHARGE_JACKPOT: "Қайта зарядтау",
  Bill_Type_RECHARGE_PRESENT: "Қайта зарядтау",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Комиссияны беру",
  Bill_Type_RECHARGE_TG_COMMISSION: "Науқандық комиссия",
  Bill_Type_REGISTER_TG_COMMISSION: "Тіркелу және жылжыту жөніндегі комиссия",
  Bill_Type_WITHDRAW: "Алу",
  Bill_Type_WITHDRAW_REJECT: "Алу",
  Bill_Type_DEDUCT_HANDLE: "Қолмен алу",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Қайта зарядтау",
  Bill_Type_MINING_PROFIT: "Тау-кен табысы",
  Bill_Type_MINING_PROFIT_COMMISSION:
    "Тау-кен орнын жылжыту жөніндегі комиссия",
  Bill_Type_VIP_UPGRADE: "VIP жаңарту",
  Bill_Type_FINANCE_BUY: "Байлық басқаруды сатып алу",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Қаржылық баланстық қайтару",
  Bill_Type_FINANCE_FEE: "Қаржылық өңдеу ақысы",
  Bill_Type_FINANCE_PROFIT: "Қаржылық кіріс",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Байлықты басқару үшін сатып алу комиссиялары",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "Байланысты басқару Өнімдегі кіріс комиссиясы",
  Bill_Type_WHEEL_DRAW: "Үлкен бұрылмалы табақ лотереясы",
  Bill_Type_BUY: "Сатып алу",
  Bill_Type_PAY_SHOP: "Төлемақы төлеу ақысы",
  Bill_Type_BUY_COMMISSION: "Сатып алу Комиссия",
  Bill_Type_DEPOSIT: "Депозит төлеңіз",
  Bill_Type_STORE_BUY: "Сатып алу",
  Bill_Type_STORE_BUY_REFUND: "Төлемді сатып алыңыз",
  Bill_Type: "Қарызды өзгерту түрі",
  Before_Money: "Алдыңғы сома",
  Deal_Money: "Шотты өзгерту сомасы",
  After_Money: "Кейінгі сома",
  Bill_Time: "Есептік жазбаны өзгерту уақыты",
  No_More_Data: "Қосымша мәліметтер жоқ",
  Apply_Money: "Өтінім сомасы",
  Apply_Time: "Өтінім уақыты",
  Withdraw_Info: "Төлемақы: {ақы}, шотқа: {ақша}",
  提款订单状态_CHECKING: "Қарау керек",
  提款订单状态_TRANSFERRING: "Ауыстыру",
  提款订单状态_PASS: "Растау",
  提款订单状态_REJECT: "Қабылданбады",
  暂无可用充值方式: "Пайдалы қайта зарядтау әдісі жоқ",
  钱包收款码: "Әмиянды жинау коды",
  钱包地址: "Әмиян мекен-жайы",
  金额限制: "Сома шегі",
  复制: "еліктеу",
  付款凭证: "Төлем ваучері",
  收款银行: "Дебиторлық банк",
  收款人: "Кассир",
  收款账号: "Түбіртек",
  付款银行: "Төлем банкі",
  付款人: "Төлеуші",
  付款账号: "Төлем шоты",
  请输入付款银行: "Төлем банкіне кіріңіз",
  请输入付款人: "Төлеушіні енгізіңіз",
  请输入付款账号: "Төлем шотын енгізіңіз",
  请上传付款凭证: "Төлем жолдамаларын жүктеңіз",
  充值金额: "Қайта зарядтау сомасы",
  请输入充值金额: "Қайта зарядтау сомасын енгізіңіз",
  submitting: "Ұсынылған ...",
  Confirm: "бағыну",
  Commit_Success: "Сәтті ұсыныс",
  balanceType_BALANCE: "Баланс",
  balanceType_COMMISSION: "тапсырыс",
  Balance: "Шоттағы қалдық",
  Wash_Money: "Кодтау",
  请选择银行账户: "Банк шотын таңдаңыз",
  卡号类型: "Карта нөмірі",
  提现金额: "Шығару сомасы",
  提款金额: "Шығару сомасы",
  不能为空: "Бос болмауы мүмкін",
  金额不正确: "Дұрыс емес мөлшер",
  please_input_withdraw_password: "Құпия сөзді енгізіңіз",
  withdraw_password_format_error:
    "Шығару паролі 4-16 биттік таңбалар болуы керек",
  Fee: "Төлемақы",
  实际到账: "Шынында",
  交易币种: "Сауда валютасы",
  原始密码: "Қарапайым пароль",
  confirm_password_error: "Екі кірістегі пароль дұрыс емес",
  save_success: "Сәтті болыңыз",
  please_input: "Енгізіңіз",
  old_password: "Ескі пароль",
  new_password: "Жаңа пароль",
  please_input_confirm_password: "Құпия сөзді қайта растаңыз",
  没有找到符合条件的商品: "Білікті өнімдер таба алмады",
  Search: "іздеу",
  全部: "бірі",
  EnumGoodsOrderState_USER_PAY: "Таратуға болады",
  EnumGoodsOrderState_SHOP_PAY: "Бөлу",
  EnumGoodsOrderState_SUCCESS: "Біту",
  EnumGoodsOrderState_CANCEL: "Күшін жою",
  EnumGoodsOrderState_REFUND_SUCCESS: "Төлеу",
  订单号: "Тапсырыс нөмірі",
  用户名称: "Пайдаланушының аты",
  收益: "табыс",
  支付时间: "Төлеу уақыты",
  配送时间: "Жеткізу уақыты",
  完成时间: "Толығымен уақыт",
  发货: "Кеме",
  全选: "Толық таңдау",
  物品已添加到愿望清单: "Элементтер тілектер тізіміне қосылды",
  物品已添加到比较列表: "Элементтер салыстыру тізіміне қосылды",
  购买成功提示: "Құттықтаймыз, сәтті сатып алыңыз",
  订单列表: "Тапсырыс тізімі",
  商品名: "Өнім атауы",
  图片: "сурет",
  没有品牌: "Бренд жоқ",
  基本信息: "Негізгі ақпарат",
  Account_Name: "Есім",
  Bank_Account: "Банктік шот",
  Bank_Phone: "Резервтік ұялы телефон нөмірі",
  IFSC: "IFSC есептік жазбасы",
  UPI: "UPI шоты",
  PIX: "PIX есептік жазба нөмірі",
  CPF: "CPF шоты",
  GCASH: "GCash шоты",
  POWWI: "Powwi шоты",
  身份证号: "Жеке куәлік нөмірі",
  Edit: "Қайта қарау",
  Delete: "жою",
  Add: "Арттыру",
  Forget_Withdraw_Password: "Құпия сөзді ұмытыңыз",
  Bank_Card_Info: "Банк картасы туралы ақпарат",
  收款人地址: "Кассирдің мекен-жайы",
  SWIFT: "Жылдам жеткізу",
  Bank_Branch: "Ішкі атау",
  分行代码: "Филиал коды",
  银行地址: "Банктің мекен-жайы",
  Email: "Электрондық пошта",
  银行卡长度必须超过: "Банк картасының ұзындығы {Ұзындығы}",
  银行卡格式不正确: "Банк картасының форматы дұрыс емес",
  Do_you_confirm_delete: "Жоюды растайсыз ба?",
  Please_Login_First: "Алдымен кіріңіз",
  Bank_Name: "Банк атауы",
  Please_add_bank_first:
    "Сіз банктік картаны байламадыңыз, оны алдымен қосыңыз",
  withdrawType: "Алып қою",
  withdraw_money_limit:
    "Шығару сомасы 0-ден көп болуы керек және {Balance} -ден кем немесе одан аз болуы керек",
  withdraw_times_limit:
    "Сіз бүгін {Toditsittrawn} рет шығардыңыз. Ақшаны алуға бел бу кете ме?",
  Copy_Success: "Репликация",
  商店首页: "Басты бетті сақтау",
  所有产品: "Барлық өнімдер",
  新到货产品: "Жаңа-жоңбалы өнім",
  所有商家: "Барлық саудагерлер",
  请上传: "Жүктеңіз",
  请输入: "Енгізіңіз",
  忘记密码: "парольді ұмытыңыз",
  记得我: "Мені ұмытпаңыз",
  共_件: "Барлығы {0} дана",
  取消订单: "Тапсырысты болдырмау",
  申请退款: "Қайтару үшін өтініш беріңіз",
  未知商家: "Белгісіз саудагер",
  到账: "Шот",
  提款订单状态: "Шығару туралы мәртебесі",
  前_名类别: "Бірінші {0} санаты",
  取消订单原因_不想要了: "Бұдан былай қаламаңыз",
  取消订单原因_商品错选_多选: "Өнімнің қателері / бірнеше таңдау",
  取消订单原因_商品无货: "-Бұналар",
  取消订单原因_地址信息填写错误: "Мекенжай туралы ақпарат қатесін толтырыңыз",
  取消订单原因_商品降价: "Тауар бағасын төмендету",
  取消订单原因_价格高于其他平台: "Бағасы басқа платформалардан жоғары",
  取消订单原因_没用_少用_错用优惠: "Ештеңе / пайдалану / қате жеңілдік",
  退款原因_拍错_多拍_不喜欢: "Дұрыс емес / түсіріңіз / ату / ұнамайды",
  退款原因_商品成分描述不符:
    "Өнім компоненттерінің сипаттамасы сәйкес келмейді",
  退款原因_与商家协商一致退款: "Саудагерді қайтарумен кеңес беру",
  退款原因_生产日期_保质期与商品描述不符:
    "Өндіріс күні / сақтау мерзімі өнім сипаттамасына сәйкес келмейді",
  退款原因_图片_产地_批号_规格等描述不符:
    "Сурет / шығу орны / пакеті саны / техникалық сипаттамалары және т.б.",
  退款原因_质量问题: "Сапа мәселесі",
  退款原因_商品变质_发霉_有异物: "Тауарлы олжа / қалып / бөгде дене",
  退款原因_少件_含缺少配件_: "Кішкентай заттар (аксессуарлардың жоқтығын қоса)",
  退款原因_收到商品时有破损_污渍_变形:
    "Өнімді алған кезде зақымдану / дақтар / деформация бар",
  退款原因_假冒品牌: "Алдау",
  退款原因_发票问题: "Шот-фактура мәселесі",
  退款原因_商家发错货: "Саудагерлер дұрыс емес тауарлар жібереді",
  退款原因_预约不到_商家不给退换: "Кездесу мүмкін емес / сатушы қайтарылмайды",
  退款失败: "Қайтару сәтсіздігі",
  退款处理中: "Қайтаруды өңдеу",
  默认: "міндеттемені орындамау",
  产品查询: "Өнім сұранысы",
  商店LOGO: "Дүкен логотипі",
  推广码: "Науқан коды",
  查看所有: "Барлығын тексеріңіз",
  确认收货成功: "Түбіртектің сәтті екенін растаңыз",
  物流公司: "Логистикалық компания",
  物流单号: "Логистикалық тапсырыс нөмірі",
  发货时间: "Жеткізу уақыты",
  请先选择商品规格: "Алдымен өнім сипаттамасын таңдаңыз",
  个人信息: "жеке ақпарат",
  您的用户名: "Сіздің логиніңіз",
  你的名字: "Сіздің атыңыз",
  登录名: "пайдаланушы аты",
  你的邮件: "Сіздің хатыңыз",
  你的密码: "Пароль",
  重复输入密码: "Парольді қайталаңыз",
  店铺名称: "Дүкен атауы",
  证书类型: "Басу",
  身份证: "Жеке куәлік",
  护照: "төлқұжат",
  驾驶执照: "Жүргізуші куәлігі",
  社会保障卡: "Әлеуметтік сақтандыру картасы",
  证书正面: "Оң сертификат",
  证书反面: "Дәлел",
  确认收货: "Тауарлардың түскенін растаңыз",
  请选择取消订单的原因必选: "Тапсырысты болдырмау себебін таңдаңыз (міндетті):",
  请选择申请退款的原因必选:
    "Қайтару үшін өтініш беру себебін таңдаңыз (міндетті):",
  留言: "хабар",
  请输入留言: "Хабарлама енгізіңіз",
  没有帐户: "Есептік жазба жоқ",
  钱包充值: "Әмиянды толтыру",
  输入您的文字: "Мәтінді енгізіңіз",
  商家登录: "Сауда-саттыққа кіру",
  有关此产品的任何查询: "Осы өнімдегі кез-келген сұрау",
  产品名称: "Өнім атауы",
  你的问题: "Сіздің проблемаңыз",
  白银店铺: "Күміс дүкені",
  铂金店铺: "Платина дүкені",
  钻石店铺: "Алмаз дүкені",
  照片: "фотосурет",
  已退货: "Оралды",
  邮寄状态: "Пошта күйі",
  订单摘要: "Рефератқа тапсырыс беру",
  收件地址: "Табыс мекен-жайы",
  订购日期: "Тапсырыс күні",
  订单状态: "Тапсырыс күйі",
  总订单金额: "Жалпы тапсырыс сомасы",
  邮寄方式: "Пошта әдісі",
  附加信息: "Қосымша ақпарат",
  订单详细信息: "Толық ақпарат",
  交货类型: "Жеткізу түрі",
  进行评论: "Ескерту",
  已评论: "Түсініктеме",
  订单金额: "Тапсырыс сомасы",
  优惠券: "Купон",
  统一运费: "Бірыңғай жүк",
  送货地址: "Жеткізілім мекен-жайы",
  评分: "есеп",
  你的意见: "Сіздің пікіріңіз",
  匿名: "аноним",
  现金: "ақша",
  详情: "Деталь",
  收货地址: "Түбіртек адресі",
  暂时没有对话: "Уақыт үшін диалог жоқ",
  你: "сен",
  输入您的回复: "Жауабыңызды енгізіңіз",
  删除成功: "Жою",
  品牌: "сорт",
  已缴纳的保证金: "Төленген маржа",
  黄金店铺: "Алтын дүкен",
  没有更多数据: "Қосымша мәліметтер жоқ",
  站内信: "-Site әрпі",
  系统通知: "Жүйелік хабарлама",
  邮箱: "Почта",
  手机号: "Телефон нөмірі",
  你的手机号: "Ұялы телефон нөміріңіз",
  营业执照: "Іскерлік лицензия",
  你的邮箱: "Сіздің пошта жәшігіңіз",
  搜索结果: "Іздеу нәтижелері",
  系统公告: "Жүйе туралы хабарландыру",
  客服: "клиенттерге қызмет көрсету",
  消息已撤回: "Жаңалықтар алынды",
  物流详情: "Логистикалық мәліметтер",
  充值: "үстіне",
  提现: "Алу",
  信用分: "Несие",
  余额: "Баланс",
  佣金: "тапсырыс",
  继续购物: "Сатып алуды жалғастырыңыз",
  订单结算: "Тапсырысты есеп айырысу",
  加入对比: "Салыстыруды қосыңыз",
  佣金余额: "Комиссияның балансы",
  刷新: "сергіту",
  刷新成功: "Сергіту",
  官网: "Ресми веб-сайт",
  税号: "Салық нөмірі",
  订单: "Бұйрық",
  合计: "жалпы",
  系统安全: "Жүйелік қауіпсіздік",
  Recharge_Money_Limit:
    "Қайта зарядтау сомасы {min} және {max} арасында болуы керек",
  限时优惠: "Шектеулі уақыт",
  高价回收: "Жоғары қайта өңдеу",
  姓名: "Есім",
  商品订单号: "Тауарлық тапсырыс нөмірі",
  商品在线回收: "Тауарды онлайн режимінде қайта өңдеу",
  提交: "бағыну",
  回收记录: "Қалпына келтіру жазбасы",
  回收状态: "Қалпына келтіру күйі",
  回收价格: "Қайта өңдеу бағасы",
  纳税码: "Салық кодексі",
  买家登录: "Кіру",
  买家注册: "тіркеу",
  language: "Қытай",
  助力提示:
    "Саудагерлерге көмек көрсету платформаның олардың дүкендеріне әсер етуін арттыра алады, және жинақталған күндер саны неғұрлым жоғары болса, экспозиция соғұрлым жоғары болады.",
  已累计助力: "Жабдықталған",
  今日已助力: "Бүгін көмектесті",
  立即助力: "Дереу көмек",
  商家助力: "Саудагер",
  证件号码: "Жеке куәлік нөмірі",
  证书号码: "Сертификат нөмірі",
  男鞋: "Ерлер аяқ киімі",
  游戏玩具: "Ойын ойыншықтары",
  使用条款: "Пайдалану шарттары",
  商家: "Саудагер",
  已助力: "Көмектесті",
  被助力: "Көмектесуге",
  用户: "пайдаланушы",
  助力记录: "Анықтама",
  消息类型: "Хабар түрі",
  消息内容: "Хабарлама мазмұны",
  链接: "Байланыс",
  文本: "мәтін",
  清空: "Айқын",
  评论成功: "Түсініктеме сәтті",
  扫描二维码: "QR кодын сканерлеңіз",
  转入: "аудару",
  收款: "Жинақ",
  任务下单中心: "Тапсырмаларға тапсырыс беру орталығы",
  记录: "жазба",
  任务倒计时: "Тапсырманы кері санау",
  倒计时后自动放弃: "Кері санаудан кейін автоматты түрде бас тарту",
  业务码: "Бизнес коды",
  选择商品分类: "Өнім санатын таңдаңыз",
  可多选: "Бірнеше таңдау мүмкін",
  加载分类中: "Санаттар жүктелуде",
  暂无分类: "Әлі классификация жоқ",
  产品类别: "Өнім санаты",
  账户余额: "Есептік баланс",
  立即结算: "Тез арада есеп айырысу",
  任务已自动放弃: "Тапсырма автоматты түрде тоқтатылды",
  商品分类: "Өнімнің классификациясы",
  订单详情: "Тапсырыс мәліметтері",
  预计收益: "Болжалды кіріс",
  预计佣金收益: "Есептелген комиссиялық кіріс",
  收益率: "Өнімділік",
  扣款账户: "Дебеттік шот",
  确认结算: "Есеп айырысуды растау",
  未选择: "Таңдалмаған",
  请选择商品分类: "Өнім санатын таңдаңыз",
  下单成功: "Тапсырыс сәтті орналастырылды",
  下单失败: "Тапсырыс орындалмады",
  请重试: "Қайталап көріңіз",
  订单记录: "Тапсырыс жазбасы",
  没有更多了: "артық емес",
  业务号: "Бизнес нөмірі",
  商品类型: "Өнім түрі",
  佣金收益: "комиссиялық кіріс",
  待结算: "Күтудегі есеп айырысу",
  已结算: "Орнықты",
  已取消: "Бас тартылды",
  加载失败: "Жүктелмеді",
  倒计时: "Кері санақ",
  随机商品: "кездейсоқ элементтер",
  为: "үшін",
  商户助力可提升商品曝光度: "Сатушының көмегі өнімнің әсерін арттыруы мүмкін",
  累计助力越高推荐权重越高:
    "Жинақталған көмек неғұрлым жоғары болса, ұсыныс салмағы соғұрлым жоғары болады.",
  实时助力动态: "Нақты уақыттағы көмек динамикасы",
  助力奖励: "Сыйақыларды көбейтіңіз",
  随机奖励金额已生成: "Кездейсоқ сыйақы сомасы жасалды",
  开心收下: "Оны қабылдауға қуаныштымын",
  助力已结束: "Көмек аяқталды",
  助力成功: "Сәттілікке көмектесіңіз",
  成功: "сәттілік",
  进行中: "Орындалуда",
  等待: "күт",
  助力失败: "Анықтама орындалмады",
  任務: "Тапсырма",
  下单失败_请稍后重试: "Тапсырыс орындалмады, кейінірек қайталап көріңіз",
  任务: "Тапсырма"
};
